<template>
    <div>
        <div class="modal-backdrop fade in"></div>
        <div class="modal modal-error" id="myModal" v-on:click.prevent="closeModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="myModalLabel">
                            <slot name="title"></slot>
                        </h4>
                    </div>
                    <div class="modal-body">
                        <slot name="body"></slot>
                    </div>
                    <div class="modal-footer" v-on:click.prevent="closeModal">
                        <button class="link-button" v-on:click.prevent="closeModal">
                            <span>Ok</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        mounted() {
            document.body.className += ' ' + 'modal-open'
        },
        methods: {
            closeModal() {
                window.location.reload(true)
            },
        },
    }
</script>


// WEBPACK FOOTER //
// Features/Shared/VueComponents/modal.vue